import React, { Component } from "react"

import Header from "../Header/Header"
import Menu from "../Menu/Menu"
import SEO from "../SEO/SEO"

import Carousel from "../Carousel/Carousel"
import FooterCarousel from "../FooterCarousel/FooterCarousel"
import ScrollToTheTopButton from "../ScrollToTheTopButton/ScrollToTheTopButton"
import ContactButton from "../ContactButton/ContactButton"
import Footer from "../Footer/Footer"

import Button from "../Button/Button"

import "./layoutHeaderMenu.scss"

class LayoutHeaderMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  updateDimensions() {
    if (typeof window !== "undefined") {
      if (window.innerWidth > 1023) {
        this.setState({ open: true })
      } else {
        this.setState({ open: false })
      }
    }
  }

  componentDidMount() {
    document.querySelector(".footer").click()
    this.updateDimensions()
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.updateDimensions.bind(this))
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateDimensions.bind(this))
    }
  }

  render() {
    const {
      siteMetadata,
      header_logo,
      header_title,
      header_description,
      header_background,
      header_shaded,
      menu,
      color,
      selected,
      selected2,
      selected3,
      expanded,
      items,
      items_videos,
      footerCarousel,
      captcha,
      footer,
    } = this.props

    return (
      <div className="layout-wrapper">
        {siteMetadata ? <SEO meta={siteMetadata} /> : null}
        <Header
          logo={header_logo}
          items={menu}
          color={color ? color : "white"}
          selected={selected}
          selected2={selected2}
          selected3={selected3}
          expanded={expanded}
          header_title={header_title}
          header_description={header_description}
          shaded={header_shaded}
          background={header_background}
        />
        <div className="layout-main">
          <div className="menu-contact-wrapper">
            <ContactButton color={color ? color : "white"} />
            <Menu
              items={menu}
              color={color ? color : "white"}
              selected={selected}
              selected2={selected2}
              selected3={selected3}
              expanded={expanded}
            />
          </div>
          <div className="layout-body">
            {items ? (
              <div className="background_picture">
                <Carousel
                  items={items}
                  items_videos={items_videos}
                  background_picture={this.props.background_picture}
                />
              </div>
            ) : (
              this.props.children
            )}
          </div>
        </div>
        {footerCarousel ? (
          <div
            className="index_carousel"
            style={
              this.state.open
                ? { flexDirection: "column-reverse" }
                : { flexDirection: "column", maxHeight: "100px" }
            }
          >
            <div className="carousel-wrapper">
              {this.state.open ? (
                <FooterCarousel
                  slidesToShow={4}
                  carousel={footerCarousel}
                  items_videos={items_videos}
                />
              ) : null}
            </div>
            <div
              className="footerCarousel-show-more"
              onClick={() => {
                if (this.state.open) {
                  this.setState({
                    open: false,
                  })
                } else {
                  this.setState({
                    open: true,
                  })
                }
              }}
            >
              <Button
                type="primary"
                model="2"
                text={
                  this.state.open ? `videók elrejtése` : `videók megtekintése`
                }
              ></Button>
            </div>
          </div>
        ) : null}
        <ScrollToTheTopButton
          delayInMs={"500ms"}
          scrollStepInPx={100}
          captcha={captcha}
        />
        <Footer footer={footer} />
      </div>
    )
  }
}

export default LayoutHeaderMenu
